// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"162":"e89261bd09c492e4","540":"64f632b0dd7603b8","701":"d7d95ef340a64731","719":"25f8d5bc50a20a2d"}[chunkId] + ".js";
};